var map = {
	"./2mtr Flag Pole.png": 1777,
	"./5 mtr flag pole.png": 3252,
	"./ABIH7627.png": 1908,
	"./Acrylic A5- L shape.png": 8339,
	"./Acrylic Brochure Holder.png": 4589,
	"./Acrylic Counter Display.png": 81,
	"./Acrylic Hinges.png": 2171,
	"./Acrylic Raffle Drum.png": 17,
	"./Acrylic Step customized display for products.png": 341,
	"./Acrylic Table Tent Sign Holder.png": 5539,
	"./Aluminium Easel Stand.png": 2323,
	"./Aluminum Easel Stand- 2.png": 9737,
	"./Application_Tape.png": 1581,
	"./Brochure holder A4 Size.png": 1842,
	"./Brochure holder A5.png": 7768,
	"./Brochure holder DL Size.png": 3627,
	"./Cosmetic Display Stand.png": 1159,
	"./Curved Exhibition Display Wall.png": 8264,
	"./Curved Fabric Backdrop  Pop-Up Display.png": 1663,
	"./Curved Premium Fabric Display.png": 6091,
	"./Custom Acrylic Step Display.png": 894,
	"./Diamond grades.png": 2384,
	"./Door Name Holder.png": 6245,
	"./Double Banner Pole Stand (V-Shape).png": 872,
	"./Double Sided Roll Up.png": 5112,
	"./Engraving sheet regular.png": 5138,
	"./FIXED POSTER STAND - A3 & A4.png": 7313,
	"./Floor Flag Poles.png": 2969,
	"./Flying Banner-3.png": 9019,
	"./Flying-Banner.png": 8094,
	"./Flyingbanners.png": 6664,
	"./Frosted Film.png": 5737,
	"./Gold Floor Flag Pole.png": 7260,
	"./HARD POUCH.png": 8858,
	"./Hanging Banner.png": 3010,
	"./ID hard pouch 2.png": 8659,
	"./ID hard pouch.png": 6513,
	"./ID pouch K-1.png": 3927,
	"./ID soft pouch 1.png": 55,
	"./ID soft pouch.png": 2822,
	"./ID soft.png": 279,
	"./INFO LINE BOARD 100 X 70.png": 116,
	"./IVCV5110.png": 1999,
	"./Info Board Chrome base - A3.png": 9846,
	"./JWSX6307.png": 3266,
	"./LANYARD- 15mm SCREENPRINT.png": 2897,
	"./LUXW5313.png": 9282,
	"./LWCR9120.png": 8464,
	"./Laser Engarving Sheet-2.png": 9372,
	"./Laser Engraving Sheet.png": 6775,
	"./Locator.png": 6952,
	"./Locatot.png": 4078,
	"./Lucky Draw Wheel.png": 3683,
	"./Magnetic name badge.png": 6632,
	"./Metal Brochure Holder.png": 7769,
	"./Micron Sheet Clear.png": 7080,
	"./Micron sheet white.png": 9304,
	"./Mini Banner Stand (Desktop Roll-Up Banner).png": 5901,
	"./Napkin & Tissue Holder.png": 9514,
	"./Netted brochure Holder- single sided.png": 7398,
	"./Netted brochure Holder.png": 7866,
	"./OKBG1262.png": 5514,
	"./Office Door Sign.png": 9015,
	"./POP UP TABLE.png": 7380,
	"./Plotting paper Roll.png": 1018,
	"./Product Grid Organizer.png": 3896,
	"./Q pole With Retractable.png": 3566,
	"./Q-pole-with-Rope.png": 6746,
	"./Queue Barrier Post (Gold Stanchion).png": 1800,
	"./Raffle Box 120 x 60.png": 4162,
	"./Raffle Box 30 x 30 x 30cm.png": 4346,
	"./Raffle drum 120 x 60.png": 7625,
	"./Raffle drum 30 x 30 x 30.png": 961,
	"./Raffle drum Table top.png": 485,
	"./Reel badges with Epoxy.png": 1651,
	"./Roll  Up.png": 4246,
	"./Roll Up 150x200 cm Print.png": 513,
	"./Roll-Up Banner Base (Retractable Banner Hardware).png": 3740,
	"./Roll-Up Banner Stand (Retractable Banner).png": 5437,
	"./Roll-Up Banner Stand.png": 201,
	"./Rotating Light Box-1.png": 6885,
	"./Rotating Light Box.png": 2307,
	"./Rotating-Light-Box.png": 9355,
	"./Sales Promotinal Table.png": 645,
	"./Silicon wrist band Pink glow in the dark.png": 208,
	"./Slider Door Sign.png": 4176,
	"./Slim Light Box With Frame.png": 4697,
	"./Slim Light Box.png": 4476,
	"./Snap Frame Mitered Corner- 2.png": 405,
	"./Snap Frame.png": 5979,
	"./Square banner 1.png": 6734,
	"./Square banner.png": 5319,
	"./Straight Fabric Backdrop.png": 5261,
	"./Straight Fabric Step-and-Repeat Backdrop.png": 9043,
	"./TABLE - DOOR NAME holder.png": 2166,
	"./Table Banner Stand (L-Style Banner Stand).png": 7827,
	"./Table Flag Stand with Flag.png": 620,
	"./Table Flag Stand.png": 2462,
	"./Table Flags.png": 8051,
	"./Teardrop Flag.png": 5761,
	"./Teardrop Flags  Feather Flags.png": 2636,
	"./Texo Red tape - Double Side.png": 9486,
	"./Texo double Side Tissue Tape.png": 6029,
	"./UQKI8025.png": 6937,
	"./Untitled design (17).png": 8824,
	"./Untitled design (39).png": 3788,
	"./Untitled design (68).png": 3430,
	"./Untitled design (69).png": 1373,
	"./Untitled design (70).png": 4591,
	"./Velcro Black.png": 6332,
	"./Velcro White.png": 5094,
	"./Wooden Easel Stand.png": 3076,
	"./Z type podium 1.png": 8397,
	"./ZigZag Brochure_Stand.png": 8239,
	"./Zigzag Brochure Holder.png": 9738,
	"./Zigzag Brochure holder with Aluminium Case-1.png": 6489,
	"./Zigzag Brochure holder with Aluminium Case.png": 7919,
	"./box type.png": 4509,
	"./customize acrylic products.png": 8304,
	"./customized glorifier.png": 9882,
	"./diamond grade.png": 8755,
	"./double sided tape (2).png": 5697,
	"./frosted.png": 4995,
	"./honey comb blue.png": 2594,
	"./honey comb green.png": 1217,
	"./honey comb.png": 9588,
	"./icons.png": 2724,
	"./info-board-black base.png": 1794,
	"./lanyard 20mm.png": 4623,
	"./podium box.png": 4475,
	"./silicon wrist band.png": 71,
	"./snap frame with Corner 25mm & 30mm.png": 7010,
	"./soft pouch.png": 7657,
	"./square banner with water Tube.png": 9146,
	"./wooden black.png": 9263,
	"./zigzag Brochure Holder A3.png": 4632
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8141;